import {BIDDABLE_TYPES as B_TYPES} from 'store/modules/bidmanager/utils/common';


export const BIDDABLE_TYPES = [
  B_TYPES.KEYWORD,
  B_TYPES.ADGROUP,
  B_TYPES.PLACEMENT_URL
];
